import baseRegistryJson from './early-childhood-registry.json';
import pack0012Json from './early-childhood-packs/0-12.json';
import pack2436Json from './early-childhood-packs/24-36.json';
import type {
  EarlyChildhoodActivityProvenance,
  EarlyChildhoodRegistry
} from './early-childhood-provenance';

interface EarlyChildhoodActivityPackJson {
  schemaVersion: 1;
  packId: string;
  ageBands: readonly string[];
  activities: readonly EarlyChildhoodActivityProvenance[];
}

const baseRegistry = baseRegistryJson as unknown as EarlyChildhoodRegistry;
const pack0012 = pack0012Json as unknown as EarlyChildhoodActivityPackJson;
const pack2436 = pack2436Json as unknown as EarlyChildhoodActivityPackJson;

export const EARLY_CHILDHOOD_REGISTRY: EarlyChildhoodRegistry = {
  ...baseRegistry,
  activities: [
    ...baseRegistry.activities,
    ...pack0012.activities,
    ...pack2436.activities
  ]
};
